import { React, useState, useEffect } from 'react';

import {
  MotifHeader,
  MotifVerticalNavigationHeaderButton as MotifVerticalNavHeaderButton,
} from '@ey-xd/motif-react';

import ey_Logo from '../../assets/icons/ey_Logo.png';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { toTitleCase } from '../../../util/commonUtil';
import { navlinks } from '../../../constants/navbarConstants';
import { useRecoilState } from 'recoil';
import { Modal_Trigger_State, PL_Commit_State } from '../../../recoil/recoil';
import ExitConformationModal from '../modals/exitConformationModal';
import { MotifMenuItem, MotifMenu } from '@ey-xd/motif-react';
import { isMobile } from 'react-device-detect';
import UserProfileDropdown from '../headerComponent/userProfileDropdown';
import '../../../styles/commonStyles.css';

const Navlinks = [
  {
    label: navlinks.dashboard,
    path: '/',
  },
  {
    label: navlinks.forecast,
    path: '/forecast',
  },
];

function Navbar({ children }) {
  let location = useLocation();
  useEffect(() => {
    setLinkActive(location.pathname);
  }, [location]);

  const [collapse, setCollapse] = useState(false);
  const [active, setActive] = useState(Navlinks[0].label);
  const [menuVisibility, setMenuVisibility] = useState(false);

  let navigate = useNavigate();

  const toggleCollapse = () => {
    setCollapse(curValue => !curValue);
  };

  const navigateToPage = link => {
    setActive(link.label);
    navigate(link.path);
  };

  const setLinkActive = path => {
    const segments = path.split('/');
    const activeLink = toTitleCase(segments[1]);

    if (activeLink == '') {
      setActive(navlinks.dashboard);
    } else if (activeLink == 'Forecast') {
      setActive('Forecasting');
    } else {
      setActive(activeLink);
    }
  };

  const [plCommitData, setPlCommitData] = useRecoilState(PL_Commit_State);
  const [showWarningModal, setShowWarningModal] = useRecoilState(Modal_Trigger_State);

  const [modalNavigate, setModalNavigate] = useState('');

  let dataObjSize = Object.keys(plCommitData).length;

  dataObjSize = dataObjSize != 0 && plCommitData.crm_update.length != 0 ? dataObjSize : 0;

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  });

  const handleBeforeUnload = e => {
    if (dataObjSize === 0) {
      return;
    }
    e.preventDefault();
    e.returnValue = '';
    return;
  };

  const showConfirmModel = link => {
    if (link.label !== navlinks.forecast && dataObjSize !== 0) {
      setShowWarningModal(true);
    } else {
      navigateToPage(link);
    }
  };

  return (
    <>
      <MotifHeader
        className="navbar-header"
        logo={<img src={ey_Logo} alt="EY Logo" />}
        leftComponents={
          <>
            {' '}
            {isMobile && (
              <MotifVerticalNavHeaderButton
                className="mobile-hamberg-menu"
                onClick={() => {
                  setMenuVisibility(true);
                }}
              />
            )}
          </>
        }
        appHeaderName={!isMobile ? 'Sales Forecasting' : ''}
        iconsContainer={
          <>
            {/* Mobile Menu */}
            {isMobile && (
              <MotifMenu
                openFromLeft
                variant="alt"
                show={menuVisibility}
                onClose={() => setMenuVisibility(false)}
                className="mobile-menu"
              >
                <MotifMenuItem>
                  <PagesText>PAGES</PagesText>
                </MotifMenuItem>
                {Navlinks.map(link => (
                  <MotifMenuItem
                    key={link.label}
                    active={active === link.label}
                    onClick={() => {
                      showConfirmModel(link);
                      setModalNavigate(link.path);
                      setMenuVisibility(false); // To close the menu overlay
                    }}
                    className="mobile-menu"
                  >
                    <MobileNavLinkText active={active === link.label}>
                      {link.label}{' '}
                    </MobileNavLinkText>
                  </MotifMenuItem>
                ))}
              </MotifMenu>
            )}

            {/* Desktop Menu */}
            {!isMobile && (
              <div>
                {Navlinks.map(link => (
                  <Tab
                    key={link.label}
                    active={active === link.label}
                    onClick={() => {
                      showConfirmModel(link);
                      setModalNavigate(link.path);
                    }}
                  >
                    {link.label}
                  </Tab>
                ))}
              </div>
            )}
            {/* <ProfileDropdown /> */}
            <UserProfileDropdown />
            <ExitConformationModal modalNavigate={modalNavigate} />
          </>
        }
      />
    </>
  );
}

// Shift this styled component to style file
export const Tab = styled.button`
  padding: 30px 20px 8px 20px;
  cursor: pointer;
  color: white;
  background-color: transparent;
  border: 0;
  outline: 0;
  border-bottom: 2px solid transparent;
  transition: ease border-bottom 150ms;
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid white;
  `}
  &:focus {
    border: 1px solid white;
  }
`;

export const MobileNavLinkText = styled.div`
  padding: 10px 0px 0px 20px;

  ${({ active }) =>
    active &&
    `
  color: #ffe600;
`}
`;

export const PagesText = styled.div`
  padding: 10px 0px 10px 20px;
  background-color: #2e2e38;
`;

export default Navbar;
